module.exports = __webpack_public_path__ + "media/honey-icons/icon-plug-uk-04d7926c.svg";